import script from "./MemberMultiselectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MemberMultiselectInput.vue?vue&type=script&setup=true&lang=js"

import "./MemberMultiselectInput.vue?vue&type=style&index=0&id=523ddb3c&lang=css"

const __exports__ = script;

export default __exports__